// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/ArrowDown.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Styles_wrapper__aQW1B {
  width: 100%;
  padding-top: 48px;
}
.Styles_wrapper__aQW1B,
.Styles_inputWrapper__-Vpiu,
.Styles_inputColumn__F09rw {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.Styles_title__0cRgL {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.Styles_inputWrapper__-Vpiu {
  width: 40%;
  padding-top: 48px;
  gap: 32px;
}

.Styles_inputColumn__F09rw {
  width: 100%;
  gap: 6px;
}
.Styles_label__jT\\+ZD {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}

.Styles_rucniUnosInput__ilHJF {
  width: 100%;
  padding: 14px 8px 14px 8px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
}
.Styles_rucniUnosSelect__FiaFB {
  padding: 8px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
  height: 44px;
  width: 103%;
  background-color: white;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: 97%;
  background-position-y: center;
  background-repeat: no-repeat;
}
.Styles_btnRow__h9j11 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  padding-top: 100px;
  padding-bottom: 24px;
}
.Styles_cancelBtn__7Qkct,
.Styles_successBtn__56kB3 {
  width: 17%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
}
.Styles_cancelBtn__7Qkct,
.Styles_successBtn__56kB3,
.Styles_label__jT\\+ZD {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.Styles_successBtn__56kB3 {
  background: #cb9c2d;
  color: #fff;
}
.Styles_successBtn__56kB3:hover {
  background-color: #9b7725;
}
.Styles_cancelBtn__7Qkct {
  background-color: #ebebeb;
  color: #808080;
}
.Styles_cancelBtn__7Qkct:hover {
  background-color: #a09f9f;
  color: #fff;
}
.Styles_error__1W3La {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #cb2d2d;
}

.Styles_description__I627p {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  margin-top: 15px;
}

.Styles_searchContainer__NeesQ {
  width: 100%;
}

.Styles_input__4PWbH::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.Styles_search__Cu9wX {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #d1d9e2;
  padding-bottom: 20px;
  margin-bottom: 50px;
}

.Styles_labelS__jmWy1 {
  border: 1px solid #d8dbdf;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  padding: 14px 8px 14px 8px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 0px 50px 0px #5f6d7e1a;
  box-sizing: border-box;
}

.Styles_inputS__rLEpc {
  border: none;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7e;
  width: 90%;
}

.Styles_inputS__rLEpc::placeholder {
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7e;
}

.Styles_inputS__rLEpc:focus {
  outline: none;
}

.Styles_searchLabel__HuvWm {
  font-size: 20px;
  font-weight: 600;
  font-family: "Inter";
  color: #4d4d4d;
}

.Styles_dropdown__Vapj1 {
  width: 400px;
  margin-top: 10px;
  position: absolute;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 5px #5f6d7e1a;
}

.Styles_dropdown__Vapj1:hover {
  cursor: pointer;
}

.Styles_dropdownItem__g93XS {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 10px;
  width: 92%;
  height: 30px;
}

.Styles_dropdownItem__g93XS:hover {
  background-color: #f2f2f2;
}

.Styles_p__XwtV6 {
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7ec7;
}

@media screen and (max-width: 850px) {
  .Styles_title__0cRgL {
    width: 90%;
    text-align: center;
  }
  .Styles_rucniUnosInput__ilHJF {
    box-sizing: border-box;
  }
  .Styles_inputWrapper__-Vpiu {
    width: 100%;
    align-items: center;
  }
  .Styles_inputColumn__F09rw {
    width: 60%;
  }
  .Styles_cancelBtn__7Qkct,
  .Styles_successBtn__56kB3 {
    width: 27%;
    margin-left: 20px;
  }
}

@media screen and (max-width: 550px) {
  .Styles_inputColumn__F09rw {
    width: 80%;
  }
  .Styles_cancelBtn__7Qkct,
  .Styles_successBtn__56kB3 {
    width: 38%;
    margin-left: 20px;
  }
}

@media screen and (max-width: 450px) {
  .Styles_inputColumn__F09rw {
    width: 94%;
  }
  .Styles_cancelBtn__7Qkct,
  .Styles_successBtn__56kB3 {
    width: 45%;
    margin-left: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/RucniUnos/Styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,yDAA2D;EAC3D,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  padding-top: 48px;\n}\n.wrapper,\n.inputWrapper,\n.inputColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.title {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.inputWrapper {\n  width: 40%;\n  padding-top: 48px;\n  gap: 32px;\n}\n\n.inputColumn {\n  width: 100%;\n  gap: 6px;\n}\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n\n.rucniUnosInput {\n  width: 100%;\n  padding: 14px 8px 14px 8px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n}\n.rucniUnosSelect {\n  padding: 8px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n  height: 44px;\n  width: 103%;\n  background-color: white;\n  appearance: none;\n  background-image: url(../../../../assets/img/ArrowDown.png);\n  background-position-x: 97%;\n  background-position-y: center;\n  background-repeat: no-repeat;\n}\n.btnRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 16px;\n  padding-top: 100px;\n  padding-bottom: 24px;\n}\n.cancelBtn,\n.successBtn {\n  width: 17%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n}\n.cancelBtn,\n.successBtn,\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.successBtn {\n  background: #cb9c2d;\n  color: #fff;\n}\n.successBtn:hover {\n  background-color: #9b7725;\n}\n.cancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.cancelBtn:hover {\n  background-color: #a09f9f;\n  color: #fff;\n}\n.error {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #cb2d2d;\n}\n\n.description {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  margin-top: 15px;\n}\n\n.searchContainer {\n  width: 100%;\n}\n\n.input::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n}\n\n.search {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 20px;\n  border-bottom: 1px solid #d1d9e2;\n  padding-bottom: 20px;\n  margin-bottom: 50px;\n}\n\n.labelS {\n  border: 1px solid #d8dbdf;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 46px;\n  padding: 14px 8px 14px 8px;\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0px 0px 50px 0px #5f6d7e1a;\n  box-sizing: border-box;\n}\n\n.inputS {\n  border: none;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n  width: 90%;\n}\n\n.inputS::placeholder {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n}\n\n.inputS:focus {\n  outline: none;\n}\n\n.searchLabel {\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"Inter\";\n  color: #4d4d4d;\n}\n\n.dropdown {\n  width: 400px;\n  margin-top: 10px;\n  position: absolute;\n  border-radius: 8px;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 10px 5px #5f6d7e1a;\n}\n\n.dropdown:hover {\n  cursor: pointer;\n}\n\n.dropdownItem {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 5px 10px;\n  width: 92%;\n  height: 30px;\n}\n\n.dropdownItem:hover {\n  background-color: #f2f2f2;\n}\n\n.p {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7ec7;\n}\n\n@media screen and (max-width: 850px) {\n  .title {\n    width: 90%;\n    text-align: center;\n  }\n  .rucniUnosInput {\n    box-sizing: border-box;\n  }\n  .inputWrapper {\n    width: 100%;\n    align-items: center;\n  }\n  .inputColumn {\n    width: 60%;\n  }\n  .cancelBtn,\n  .successBtn {\n    width: 27%;\n    margin-left: 20px;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .inputColumn {\n    width: 80%;\n  }\n  .cancelBtn,\n  .successBtn {\n    width: 38%;\n    margin-left: 20px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .inputColumn {\n    width: 94%;\n  }\n  .cancelBtn,\n  .successBtn {\n    width: 45%;\n    margin-left: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Styles_wrapper__aQW1B`,
	"inputWrapper": `Styles_inputWrapper__-Vpiu`,
	"inputColumn": `Styles_inputColumn__F09rw`,
	"title": `Styles_title__0cRgL`,
	"label": `Styles_label__jT+ZD`,
	"rucniUnosInput": `Styles_rucniUnosInput__ilHJF`,
	"rucniUnosSelect": `Styles_rucniUnosSelect__FiaFB`,
	"btnRow": `Styles_btnRow__h9j11`,
	"cancelBtn": `Styles_cancelBtn__7Qkct`,
	"successBtn": `Styles_successBtn__56kB3`,
	"error": `Styles_error__1W3La`,
	"description": `Styles_description__I627p`,
	"searchContainer": `Styles_searchContainer__NeesQ`,
	"input": `Styles_input__4PWbH`,
	"search": `Styles_search__Cu9wX`,
	"labelS": `Styles_labelS__jmWy1`,
	"inputS": `Styles_inputS__rLEpc`,
	"searchLabel": `Styles_searchLabel__HuvWm`,
	"dropdown": `Styles_dropdown__Vapj1`,
	"dropdownItem": `Styles_dropdownItem__g93XS`,
	"p": `Styles_p__XwtV6`
};
export default ___CSS_LOADER_EXPORT___;
